import React from "react";
import "./Group258.css";

function Group258(props) {
  const { className } = props;

  return (
    <div className={`group-258 ${className || ""}`}>
      <div className="ellipse-25-1"></div>
      <div className="ellipse-26-2"></div>
      <div className="ellipse-27-2"></div>
    </div>
  );
}

export default Group258;
